// extracted by mini-css-extract-plugin
export default {"buttons":"deleteItem_buttons__RuYH2","closeBtn":"deleteItem_closeBtn__J3ovX","save":"deleteItem_save__Cy6e2","close":"deleteItem_close__DVH6X"};